module.exports = __webpack_public_path__ + "media/images/icons/material/eye-f26b036cc68826ebd5948b2693ccf9f4.svg";